import { Component, Input } from "@angular/core";
import { Store } from "@ngrx/store";
import { FileEventType } from "libs/media/src/lib/components/file-upload/file-upload-box";
import { AppState } from "libs/tm-common/src/lib";
import { ExtraoralImagesOrcadent, IntraoralImagesOrcadent, MiscellaneousImagesOrcadent, OrcadentImageOptions } from "./orcadent-image-types";
import { AnamneseFileInfo } from "libs/anamnese/src/lib/store/anamnese.reducer";
import { MediaFileOrcadentDeletedAction, MediaFileOrcadentUploadedAction } from "libs/anamnese/src/lib/store/anamnese.actions";
import { AnamneseOrcadentUploadType, MediaModel } from "libs/media/src/lib/models/media.model";
import { TranslateService } from "@ngx-translate/core";

@Component({
	selector: "anamnese-orcadent-images",
	templateUrl: "./anamnese-images-orcadent.component.html",
	styleUrl: "./anamnese-images-orcadent.component.scss"
})
export class AnamneseOrcadentImagesComponent {

	@Input({required:true}) patientId: string;
	@Input({required:true}) uploadedImageFiles: AnamneseFileInfo[];

	ExtraoralImages: OrcadentImageOptions[] = ExtraoralImagesOrcadent;
	IntraoralImages: OrcadentImageOptions[] = IntraoralImagesOrcadent;
	MiscellaneousImages: OrcadentImageOptions[] = MiscellaneousImagesOrcadent;

	constructor(
		private store: Store<AppState>,
		private translateService: TranslateService
	){

	}

	onFileEvent($event, uploadType: AnamneseOrcadentUploadType) {
		const mediaId = $event.payload?.id
		const orgFilename = $event.payload?.orgFilename;

		switch ($event.type) {
			case FileEventType.UPLOADED:
				this.store.dispatch(new MediaFileOrcadentUploadedAction(uploadType, mediaId, orgFilename) )
				break;
			case FileEventType.ERROR:
				console.error('File Upload Error', $event.payload);
				break;
			case FileEventType.DELETED:
				this.store.dispatch(new MediaFileOrcadentDeletedAction(uploadType))
				break;
		}
	}

	/**
	 * Returns the mediaModel of the related imagetype
	 * Mainly important if the user goes back during ordering process.
	 */
	getMediaModelForId(id: AnamneseOrcadentUploadType): Partial<MediaModel>{
		let item = this.uploadedImageFiles?.find( elem => id === elem.orcadentType);
		if (!item){
			return null;
		}
		return {
			_id: item.mediaId,
			orgFilename: item.orgFilename
		};
	}

	hasAlternatingAssets(id: AnamneseOrcadentUploadType) : boolean{
		return id === AnamneseOrcadentUploadType.MISC_FRS
			|| id === AnamneseOrcadentUploadType.MISC_OPG;
	}

	getBackgroundImage(id: AnamneseOrcadentUploadType): string{
		const item = MiscellaneousImagesOrcadent.find((entry) => id === entry.id );
		return this.translateService.currentLang === 'de'
			? item?.assets?.de
			: item?.assets?.en;
	}
}
